// import { getters } from './types';

export default {};
